import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class VehicleEndpoints {
  constructor(private http: HttpClient) {}
}
